export default __webpack_public_path__ + "static/media/background.3fa4945c.jpg";